import { Injectable } from "@angular/core";
import { ChangePassEndpoint } from "@app/services/authentication/change-pass-endpoints.service";
import { ChangePasswordModel } from "@app/models/changepasswordmodel";
import { Router} from '@angular/router';
import { resetPassword } from "@app/models/OTPResult";


@Injectable()
export class ChangePassService {

  constructor(private router: Router,
    private changePassEndpoint: ChangePassEndpoint) {
  }

  putPasswordChange(data: ChangePasswordModel) {
    return this.changePassEndpoint.putPasswordChange(data);
  }

  updatePassword(resetPassword: resetPassword) {
    return this.changePassEndpoint.updatePassword(resetPassword);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication/change-pass.service.ts